import { render, staticRenderFns } from "./eds-iit-checkbox-form.vue?vue&type=template&id=f5a40968&scoped=true&lang=pug"
import script from "./eds-iit-checkbox-form.vue?vue&type=script&lang=js"
export * from "./eds-iit-checkbox-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a40968",
  null
  
)

export default component.exports